import React from 'react'
import AllProducts from './../AllProducts/AllProducts';
import CategorySlider from './../CategorySlider/CategorySlider';
import MainSlider from './../MainSlider/MainSlider';
import {Helmet} from "react-helmet";


export default function Home({userData}) {
  return (
    <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Fresh Cart </title>
    </Helmet>
    <MainSlider/>
    <CategorySlider/>
    <AllProducts userData = {userData}/>
    </>
    
  )
}
